import React, { useMemo } from 'react';
import ValueView from './ValueView';
import useT from '../../utils/Translations/useT';
const SimpleValueView = ({ isMultiline = false, noLabel = false, value, label, className, valueClassName, }) => {
    const t = useT();
    const stringValue = useMemo(() => (value !== null && value !== undefined ? String(value) : ' '), [t, value]);
    return (<ValueView className={className} isMultiline={isMultiline} label={label} noLabel={noLabel} value={stringValue} valueClassName={valueClassName}/>);
};
export default SimpleValueView;
